import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { timePeriodSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type FileChangesConfig = typeof FileChangesConfig._.Config;

export const FileChangesConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.FileChanges,
  configSchema: z.object({
    repositoryName: z.string().min(1),
    branch: z.string().optional(),
    path: z.string().min(1),
    timePeriod: timePeriodSchema,
  }),
});
